import { render, staticRenderFns } from "./southcargo.vue?vue&type=template&id=16ef9f9a&scoped=true&"
import script from "./southcargo.vue?vue&type=script&lang=js&"
export * from "./southcargo.vue?vue&type=script&lang=js&"
import style0 from "./southcargo.vue?vue&type=style&index=0&id=16ef9f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef9f9a",
  null
  
)

export default component.exports